import { Navigate, Route, Routes } from "react-router-dom";
import New from "./New";
import Edit from "./Edit";
import Index from "./Index";

const CustomerRoutes = () => {
    
    return (
        <Routes>

            <Route path={`new`} element={<New />}/>

            <Route path={`edit/:id`} element={<Edit />}/>

            <Route path={`/`} element={<Index />}/>

            <Route path={"*"} element={<Navigate to={"/customers"}/>}/>
        </Routes>
    )
}

export default CustomerRoutes
